import {
  CURRENT_LOCATION_FAIL,
  CURRENT_LOCATION_SUCCESS,
} from "../Constants/CurrentLocationConstants";

const getCurrentPosition = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported."));
    } else {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 0,
      });
    }
  });

export const getCurrentLocation = () => async (dispatch) => {
  console.log("[getCurrentLocation] Started");

  try {
    const position = await getCurrentPosition();
    console.log("[getCurrentLocation] Position obtained:", position);

    const { latitude, longitude, accuracy } = position.coords;
    const isLowAccuracy = accuracy > 5000;

    console.log(
      `[getCurrentLocation] coords -> lat: ${latitude}, lon: ${longitude}, accuracy: ${accuracy}`,
    );

    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
    );

    if (!response.ok) {
      throw new Error(
        `Reverse geocoding failed with status ${response.status}`,
      );
    }

    const data = await response.json();
    const address = data.address || {};

    const location = {
      latitude,
      longitude,
      confidence: isLowAccuracy ? "low" : "high",
      country: address.country || "Unknown",
      state: address.state || "",
      city: !isLowAccuracy
        ? address.neighbourhood ||
          address.suburb ||
          address.city_district ||
          address.city ||
          address.town ||
          address.village ||
          ""
        : "",
    };

    console.log("[getCurrentLocation] Final location object:", location);

    dispatch({
      type: CURRENT_LOCATION_SUCCESS,
      payload: location,
    });
  } catch (error) {
    console.error("[getCurrentLocation] Error:", error);

    let message = error.message;

    if (error.code === 1) {
      message = "User denied geolocation permission.";
    } else if (error.code === 2) {
      message = "Position unavailable.";
    } else if (error.code === 3) {
      message = "Geolocation request timed out.";
    }

    dispatch({
      type: CURRENT_LOCATION_FAIL,
      payload: message,
    });
  }
};
